<template>
    <div class="m-footer">
      <div class="footer-left">
          <p>联系客服</p>
          <a href="tel:(0553)8820061">
              <p class="footer-telephone">0553-8820039</p>
          </a> <br/>
          <a href="mailto:kf@qutoutiao.net">
              <p class="footer-mail">
                  Email：kf@qutoutiao.net
              </p>
          </a>
      </div>
      <div class="footer-right">
          <p>商务邮箱</p>
          <a href="mailto:bd@qutoutiao.net">
              <p class="footer-mail">
                  Email：bd@qutoutiao.net
              </p>
          </a>

      </div>
      <p class="footer-address">上海市浦东新区 懿德路519号浦东软件园8号楼</p>
      <p class="footer-address opacity6 paddingTop5">© 2017 上海基分文化传播有限公司沪B2-20170289沪网文[2016]5843-427号  </p>
    </div>
</template>

<script>
export default {
    name: 'Footer',
};
</script>

<style lang="less">
.m-footer {
    font-family: PingFangSC-Regular;
    width: 100%;
    height: 6.6rem;
    box-sizing: border-box;
    padding-top: 20px;
    background-color: #f9fafb;
}
.footer-left {
    vertical-align: top;
    width: 50%;
    padding-left: 17px;
    display: inline-block;
    font-size: 12px;
    color: #898d95;
    letter-spacing: 0;
}
.footer-right {
    vertical-align: top;
    width: 50%;
    padding-left: 17px;
    display: inline-block;
    font-size: 12px;
    color: #898d95;
    letter-spacing: 0;
}
.footer-telephone {
    box-sizing: border-box;
    display: inline-block;
    background: #41b466;
    color: #ffffff;
    border-radius: 2px;
    font-size: 12px;
    text-align: left;
    letter-spacing: 0;
    margin-top: 5px;
    height: 23px;
    width: 98px;
    line-height: 23px;
    padding-left: 5px;
}
.footer-mail {
    display: inline-block;
    height: 23px;
    font-size: 12px;
    color: #898d95;
    letter-spacing: 0;
    text-align: left;
    margin-top: 5px;
}
.footer-address {
    max-width: 10.7rem;
    font-size: 12px;
    color: #898d95;
    letter-spacing: 0;
    line-height: 17px;
    padding-left: 17px;
}
.opacity6 {
    opacity: 0.6;
}
.paddingTop5 {
    padding-top: 5px;
}
</style>
